import Fetch from '@/utils/fetch';
import { Models } from '@mtap-smartcity/api';

const getDeviceDetailsSettings = (deviceType: Models.Constants.DeviceType): Promise<Models.Devices.DeviceDetailField[]> => Fetch<Models.Devices.DeviceDetailField[]>(`/api/bff/settings/details/${deviceType}`, { method: 'GET' });

const addDeviceDetailsField = (
  deviceType: Models.Constants.DeviceType,
  field: Models.Devices.DeviceDetailField
): Promise<void> => Fetch<void>(`/api/bff/settings/details/${deviceType}/fields`, {
  method: 'POST',
  body: field
});

const removeDeviceDetailsField = (
  deviceType: Models.Constants.DeviceType,
  fieldName: string
): Promise<void> => Fetch<void>(`/api/bff/settings/details/${deviceType}/fields/${fieldName}`, { method: 'DELETE' });

const getDeviceHints = (deviceType: Models.Constants.DeviceType): Promise<Models.Devices.DeviceDetailField[]> => Fetch<Models.Devices.DeviceDetailField[]>(`/api/bff/settings/hints/${deviceType}`, { method: 'GET' });

const addDeviceHintsField = (
  deviceType: Models.Constants.DeviceType,
  field: Models.Devices.DeviceDetailField
): Promise<void> => Fetch<void>(`/api/bff/settings/hints/${deviceType}/fields`, {
  method: 'POST',
  body: field
});

const removeDeviceHintsField = (
  deviceType: Models.Constants.DeviceType,
  fieldName: string
): Promise<void> => Fetch<void>(`/api/bff/settings/hints/${deviceType}/fields/${fieldName}`, { method: 'DELETE' });

export {
  getDeviceDetailsSettings,
  addDeviceDetailsField,
  removeDeviceDetailsField,
  getDeviceHints,
  addDeviceHintsField,
  removeDeviceHintsField
};
